import React, { useEffect } from "react";

import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Dropdown from "../../../components/Common/ReactForm/Dropdown/Dropdown";
import {
  Outlet,
  useLocation,
  useNavigate,
  useOutletContext,
} from "react-router";
import classes from "./GraphicalReportPage.module.scss";
import MainLayout from "../../../components/Common/MainLayout/MainLayout";
import { graphicalReport } from "../../../utils/mainTabs/reports/graphicalReport";
import Input from "../../../components/Common/ReactForm/Input/Input";
import UserGraphicalReport from "./UserGraphicalReportPage/UserGraphicalReport";
import ClassGraphicalReport from "./ClassGraphicalReportPage/ClassGraphicalReport";
import Button from "../../../components/Common/Button/Button";
import UserIcon from "../../../components/Common/SvgIcons/ReportIcons/UserIcon";
import ClassIcon from "../../../components/Common/SvgIcons/ReportIcons/ClassIcon";

const GraphicalReport = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const reportState = useSelector((state) => state.reportReducer);
  const { navLinks } = graphicalReport;
  const { buttons } = graphicalReport;
  const { tenantName } = useOutletContext();
  return (
    <MainLayout
      // heading={name}
      isReportBtn
      buttons={buttons(navigate, tenantName)}
      navLinks={navLinks(navigate, tenantName)}
    >
      <Outlet />
    </MainLayout>
  );
};

export default GraphicalReport;
